import { render, staticRenderFns } from "./VBUploadObjectsContinuousTable.vue?vue&type=template&id=bf1c0e80&scoped=true&"
import script from "./VBUploadObjectsContinuousTable.vue?vue&type=script&lang=js&"
export * from "./VBUploadObjectsContinuousTable.vue?vue&type=script&lang=js&"
import style0 from "./VBUploadObjectsContinuousTable.vue?vue&type=style&index=0&id=bf1c0e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1c0e80",
  null
  
)

export default component.exports